import React from 'react';

export const dragOverlayStyle = {
  pointerEvents: 'none' as React.CSSProperties['pointerEvents'],
  boxShadow: '14px 13px 20px 0 rgba(0, 0, 0, 0.2)',
};
